import * as Style from "./styles";

export function ListaCategorias({
  currentCategory,
  setCategory = () => {},
  listCategory = [{}],
}) {
  function handleOnClick(category) {
    if (currentCategory === category) {
      setCategory("all");
    } else {
      setCategory(category);
    }
  }

  return (
    <Style.Container>
      {listCategory?.map((item) => (
        <Style.TagFlag
          key={item.id}
          selected={item.titulo === currentCategory ? true : false}
          onClick={() => {
            handleOnClick(item.titulo);
          }}
        >
          {item.titulo}
        </Style.TagFlag>
      ))}
    </Style.Container>
  );
}
